import _http from './_http';
let http = _http;
const baseUrlScheduleOffer = '/users';

// for test MOCK
// if (process.env.MOCK) {
//   const mock = require('./_mock.json');
//   http = {
//     get: schedule =>
//       Promise.resolve().then(() => {
//         if (schedule) {
//           return Promise.reject(mock.schedule.error);
//         }

//         return { data: mock.schedule.success };
//       }),
//   };
// }

export default {
  url: `${http.baseUrl}${baseUrlScheduleOffer}`,
  post(postData) {
    console.log('POST axios: ', `${baseUrlScheduleOffer}`, postData);
    return http
      .post(
        `${baseUrlScheduleOffer}/${postData.userId}/schedules/${
          postData.scheduleId
        }/offers/${postData.offerId}/accept`,
        postData.data
      )
      .then(({ data }) => data.data)
      .catch(({ response }) => {
        if (response && response.data) {
          throw response.data.error;
        }

        throw response;
      });
  },
  get(ids) {
    console.log('GET axios: ', `${baseUrlScheduleOffer}`, ids);
    return http
      .get(
        `${baseUrlScheduleOffer}/${ids.userId}/schedules/${
          ids.scheduleId
        }/offers/${ids.offerId}`
      )
      .then(({ data }) => data.data)
      .catch(({ response }) => {
        if (response && response.data) {
          throw response.data.error;
        }

        throw response;
      });
  },
};
